import React, { useEffect, useState } from 'react';
import {useParams, Link, useNavigate, useLocation  } from 'react-router-dom';

function CategorySearch() {
  const { categoryID } = useParams();
  const { categoryName } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const prevQuery = location.state && (location.state.prevQuery || location.state.search) || '';
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [items, setItems] = useState([]);
  const [pageInfo, setPageInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [siteName, setSiteName] = useState('');

  useEffect(() => {
    fetch('/api/config/siteName')
      .then(res => res.json())
      .then(data => setSiteName(data.siteName))
      .catch(err => console.error(err));
  }, []);

  const fetchByTopic = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/searchByCategory?categoryID=${categoryID}&page=${page}&size=${size}`, {
             method: 'GET'
             }
             )
      const body = await res.json();
      setItems(body.content || []);
      setPageInfo({
        page: body.number ?? page,
        size: body.size ?? size,
        totalPages: body.totalPages ?? 1
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchByTopic(); }, [categoryID, page, size]);

  // Update document title
  useEffect(() => {
    if (categoryName) {
      document.title = `Articles on topic: ${categoryName}`;
    }
  }, [categoryName]);

  const truncateText = (html, maxLength) => {
    if (!html) return '';
    // Replace content of image and table tags with an empty string
    let cleanText = html.replace(/<img[^>]*>/g, '').replace(/<table[^>]*>[\s\S]*?<\/table>/g, '');
    // Replace all other HTML tags with an empty string
    cleanText = cleanText.replace(/<[^>]+>/g, '');
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength) + '...';
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 20,         backgroundColor: 'black',
      color: 'gold', }}>
      <Link
          to={prevQuery ? "/aisearch" : "/"}
          state={{ query: prevQuery }}
          style={{ color: 'green', textDecoration: 'none' }}
      >
        {prevQuery ? "← back to search" : "← Go to site sections"}
      </Link>
      <h2>Articles on topic: {categoryName}</h2>

      {loading && <p>Loading...</p>}

      <ul style={{ listStyle: 'none', padding: 0 }}> {/* Changed to ul for line-by-line display */}
        {items.map((it, idx) => (
          <li key={idx} style={{
            marginBottom: 20, // Spacing between items
            padding: 15,
            border: '1px solid #ddd',
            borderRadius: 8,
            background: '#fff',
            color: "black",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start' // Align content to the start
          }}>
            {it.imageUrl && (
              <img 
                src={it.imageUrl} 
                alt="" 
                style={{ 
                  width: '20%', // Reduced image size
                  height: 'auto', 
                  borderRadius: 4, 
                  marginBottom: 10 
                }} 
              />
            )}
            <h3 style={{ margin: '0 0 10px 0' }}>
              <Link 
                to={`/article/${encodeURIComponent(it.id)}`}
                state={{ prevQuery: prevQuery }}
                style={{ textDecoration: 'none', color: 'green' }}
              >
                {it.title}
              </Link>
            </h3>
            <div style={{ margin: '0 0 10px 0', whiteSpace: 'pre-wrap' }}>
              {truncateText(it.text, 300)} {/* Truncated text */}
            </div>
            <Link
              to={`/article/${encodeURIComponent(it.id)}`}
              state={{ prevQuery: prevQuery }}
              style={{ color: 'green', textDecoration: 'none' }}
            >
              to full article
            </Link>
            <div style={{ marginTop: 10, fontSize: '0.9em', color: 'green' }}>
              <a href={it.directLink} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', color: 'green', textDecoration: 'none' }}>
                Subscribe to author's channel
              </a>
            </div>
          </li>
        ))}
      </ul>

      {pageInfo && (
        <div style={{ marginTop: 16 }}>
          <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={pageInfo.page <= 0}>Previous page</button>
          <span style={{ margin: '0 12px' }}>Page {pageInfo.page + 1} of {pageInfo.totalPages}</span>
          <button onClick={() => setPage(p => (p + 1 < pageInfo.totalPages ? p + 1 : p))} disabled={pageInfo.page + 1 >= pageInfo.totalPages}>Next page</button>
        </div>
      )}
    </div>
  );
}

export default CategorySearch;
